import { useAppSelector } from '@hooks/useAppSelector';
import { useAppDispatch } from '@hooks/useDispatch';
import { FileWithPath } from '@mantine/dropzone';
import { selectHideImages } from '@store/Spreadsheet/displaySlice';
import { setEditingCell } from '@store/Spreadsheet/editingSlice';
import { updateRow } from '@store/Spreadsheet/rowsSlice';
import { useCallback, useEffect, useState } from 'react';
import { CommonCellProps } from '../Cell';
import classes from '../Cell.module.css';
import ImageUploadModal from './ImageUploadModal';
import { Image } from '@mantine/core';
import { cellValueChanged } from '@store/Spreadsheet/cellChangesSlice';

export default function CellImage({ rowId, columnId, isEditing, value, currentRow }: CommonCellProps ) {
  const dispatch = useAppDispatch();
  const hideImages = useAppSelector( selectHideImages );

  const [ localValue, setLocalValue ] = useState<string>( value ?? '' );
 
  useEffect(() => {
    setLocalValue( String( value ?? '' ));
  }, [value]);

  const commitEdit = useCallback(() => {
    if ( !currentRow ) return;
    const newValues = { ...currentRow.values, [columnId]: localValue };
    dispatch( updateRow({ id: rowId, changes: { values: newValues }}));
    dispatch( cellValueChanged({ rowId, columnId, oldValue: currentRow.values[columnId],newValue: localValue }));
    dispatch( setEditingCell( null ));
  }, [ dispatch, rowId, columnId, currentRow, localValue ]);

  const cancelEdit = useCallback(() => {
    dispatch( setEditingCell( null ));
  }, [dispatch]);
  

  const handleDrop = useCallback(( files: FileWithPath[]) => {
    if ( files.length > 0 ) {
      //TODO: aca hacer la carga temp a aws
      const objectUrl = URL.createObjectURL( files[0]);
      setLocalValue( objectUrl );
    }
  }, []);

  return (
    <>
      {!isEditing ? (
        !value ? (
          <span className={classes.cellValue}>{value}</span>
        ) : hideImages ? (
          <span className={classes.cellValue}>{value}</span>
        ) : (
          <div
            className={classes.cellValue}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Image
              src={value}
              alt=""
              radius="sm"
              h={52}
              w="auto"
              fit="contain"
            />
          </div>
        )
      ) : <span className={classes.cellValue}>{value}</span>}

     <ImageUploadModal
      isEditing={isEditing} 
      value={value}
      localValue={localValue}
      handleDrop={handleDrop}
      commitEdit={commitEdit}
      cancelEdit={cancelEdit}
     />
    </>
  );
}